import React, { useMemo } from 'react';
import { TypeCard } from '../../../../components/TypeCard';
import { ProductItemProps } from '../../../../models/Product';

const stethoscopeIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/estetoscopio.svg';
import { useContextSelector } from 'use-context-selector';
import { ServiceContext } from '../../../../contexts/ServiceContext';
import { handleProductName } from '../../../../utils';
import { useGenericModal } from '../../../../hooks/useGenericModal';
import { TypeCardCheck } from '../../../../components/TypeCardCheck';

type ProductListProps = {
  products: ProductItemProps[];
  setProductList: (list: ProductItemProps[]) => void;
  selected?: ProductItemProps[];
  onChange?: (products: ProductItemProps[]) => void;
};

export const ProductListMult: React.FC<ProductListProps> = ({ products, setProductList, selected = [], onChange }) => {
  const { addGenericModals } = useGenericModal({});

  const { selectedService } = useContextSelector(ServiceContext, state => state);

  function orderProductsByPriority(products: ProductItemProps[]) {
    return products.sort((product, product2) => {
      return Number(product.priority) - Number(product2.priority);
    });
  }

  React.useEffect(() => {
    if (selectedService) {
      const productsOrdered = orderProductsByPriority(selectedService.products);
      setProductList(productsOrdered);
    }
  }, [selectedService]);

  function handleClick(product: ProductItemProps) {
    addGenericModals({
      productRules: product.rules
    });

    const selectedProducts = [...selected];

    const index = selectedProducts.findIndex(({ id }) => id === product.id);

    if (index === -1) {
      selectedProducts.push(product);
    } else {
      selectedProducts.splice(index, 1);
    }

    onChange?.(selectedProducts);
  }

  const selectedMap = useMemo(() => {
    const map = new Map<string, ProductItemProps>();
    selected?.forEach(product => map.set(product.id, product));
    return map;
  }, [selected]);

  return (
    <>
      {products.map(product => (
        <TypeCardCheck
          key={product.id}
          title={handleProductName(product.name)}
          onClick={() => handleClick(product)}
          checked={selectedMap.has(product.id)}
        />
      ))}
    </>
  );
};
